import React, { Component } from 'react';
import { withIonLifeCycle } from '@ionic/react';
import { BehaviorSubject } from 'rxjs';
import api, { onRefreshing } from '../../../../services/api';
import { formatDateApi, formatCurrency } from '../../../../utils/formats';
import Card from '../../Card';
import PieChart from '../../../Charts/PieChart';

const onSelect = new BehaviorSubject();

class CardRecebimentosFinanceiro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      refreshing: false,
      period: '',
      data: null,
    };
    this.subscriptionRefresh = null;
    this.subscriptionSelect = null;
    this.asyncRequest = null;
  }

  componentDidMount() {
    this.subscriptionRefresh = onRefreshing.subscribe(() => {
      const dataInicial = formatDateApi(new Date());
      const dataFinal = formatDateApi(new Date());

      onSelect.next({ dataInicial, dataFinal });
    });
    this.subscriptionSelect = onSelect.subscribe(data => {
      const { periodo, ...headers } = data;
      this.setState({ period: periodo });
      if (headers.dataInicial !== undefined || headers.dataFinal !== undefined) {
        this.setState({
          refreshing: true,
          data: {
            series: [],
          },
        });
        this.asyncRequest = api
          .get('/financeiro/recebimento-previsto-realizado/', { headers })
          .then(({ data }) => {
            this.asyncRequest = null;
            const { valorPrevisto, valorRealizado } = data[0];
            this.setState({
              refreshing: false,
              data: {
                series: [
                  {
                    name: 'recebimentos',
                    colorByPoint: true,
                    data: [
                      {
                        name: 'REALIZADO',
                        y: valorRealizado,
                        color: '#F9C94E',
                      },
                      {
                        name: 'PREVISTO',
                        y: valorPrevisto,
                        color: '#068290',
                      },
                    ],
                  },
                ],
              },
            });
          });
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props?.periodo !== prevProps.periodo) {
      const headers = {};
      headers.dataInicial = this.props.dateRange.dataInicial;
      headers.dataFinal = this.props.dateRange.dataFinal;
      this.setState({ period: this.props.periodo });
      if (headers.dataInicial && headers.dataFinal) {
        this.setState({
          refreshing: true,
          data: {
            series: [],
          },
        });
        this.asyncRequest = api
          .get('/financeiro/recebimento-previsto-realizado/', { headers })
          .then(({ data }) => {
            this.asyncRequest = null;
            const { valorPrevisto, valorRealizado } = data[0];
            this.setState({
              refreshing: false,
              data: {
                series: [
                  {
                    name: 'recebimentos',
                    colorByPoint: true,
                    data: [
                      {
                        name: 'REALIZADO',
                        y: valorRealizado,
                        color: '#F9C94E',
                      },
                      {
                        name: 'PREVISTO',
                        y: valorPrevisto,
                        color: '#068290',
                      },
                    ],
                  },
                ],
              },
            });
          });
      }
    }
  }

  componentWillUnmount() {
    if (this.subscriptionRefresh) this.subscriptionRefresh.unsubscribe();
    if (this.subscriptionSelect) this.subscriptionSelect.unsubscribe();
  }

  onChangeDate = ({ dataInicial, dataFinal, periodo }) => {
    onSelect.next({ dataInicial, dataFinal, periodo });
  };

  render() {
    const { period, data, refreshing } = this.state;
    return (
      <>
        <Card
          title="Recebimentos (Previsto x Realizado)"
          className="card card__primary"
          period={period}
          onChangeDate={this.onChangeDate}>
          <PieChart
            refreshing={refreshing}
            data={data}
            options={{
              chart: {
                height: 200,
              },
              plotOptions: {
                pie: {
                  startAngle: -90,
                  endAngle: 90,
                  center: ['50%', '75%'],
                  allowPointSelect: true,
                  cursor: 'pointer',
                  dataLabels: {
                    style: {
                      color: '#fff',
                      fontWeight: 600,
                      border: 'none',
                    },
                    enabled: true,
                    formatter: function() {
                      return formatCurrency(this.y);
                    },
                  },
                },
              },
            }}
          />
        </Card>
      </>
    );
  }
}

export default withIonLifeCycle(CardRecebimentosFinanceiro);
